import { useLingui } from '@lingui/react';
import { cn } from '@/lib/utils';
import type { SlotTimeRun } from '@/types/coverage';

interface SurplusRunBadgeProps {
  runs: SlotTimeRun[];
  className?: string;
}

/**
 * Names the first surplus-staff window of a group's day, and the last one when it
 * differs, e.g. "Surplus 06:30-08:30, 16:30-18:00". Renders nothing without runs.
 */
export function SurplusRunBadge({ runs, className }: SurplusRunBadgeProps) {
  const { i18n } = useLingui();

  if (runs.length === 0) return null;

  const first = runs[0];
  const last = runs[runs.length - 1];
  const format = (run: SlotTimeRun) => `${run.start}-${run.end}`;
  const windows =
    runs.length > 1 ? `${format(first)}, ${format(last)}` : format(first);

  return (
    <span
      className={cn(
        'inline-block max-w-full truncate rounded bg-muted px-1.5 py-0.5 text-xs font-normal text-muted-foreground',
        className
      )}
    >
      {i18n._({
        id: 'shifts.slotCoverage.surplusRuns',
        message: 'Surplus {windows}',
        values: { windows },
      })}
    </span>
  );
}
